export default {
  title: 'Offres exclusives',
  header: {
    back: 'Retour',
    title: 'Récompenses',
  },
  info: {
    title: 'Vous avez {{points}} points.',
    description:
      'Dépensez {{amount}} pour obtenir 5 points ! Ajoutez des articles gratuitement grâce à vos points cumulés.',
  },
  rewards: {
    data: [
      {
        title: 'Gagnez des points à chaque commande',
        description: 'Chaque {{amount}} dépensé ajoute 5 points à votre compte.',
      },
      {
        title: 'Gagnez des points à chaque commande',
        description:
          "Échangez vos points contre des articles gratuits ! Les rachats commencent à 350 points, soit l'équivalent de {{amount}} dépensés.",
      },
      {
        title: 'Gagnez des points à chaque commande',
        description:
          "Découvrez des offres, promotions et réductions exclusives. Consultez les offres réservées aux membres dans l'app.",
      },
    ],
  },
};
